export enum ClubCapability {
  // 7.1 Club – Discovery & Maps
  DISCOVERY_BASIC_PROFILE = "club.discovery.basic_profile",
  DISCOVERY_HARBOR_LIST_BASIC = "club.discovery.harbor_list_basic",
  DISCOVERY_MY_CLUBS_FILTER = "club.discovery.my_clubs_filter",

  // 7.2 Club – Bookings & Payments
  BOOKINGS_INTERNAL_BERTH_MANAGEMENT_BASIC = "club.bookings.internal_berth_management_basic",
  BOOKINGS_ONLINE_BOOKINGS_FOR_CLUB_HARBORS = "club.bookings.online_bookings_for_club_harbors",
  BOOKINGS_MEMBER_PRICING_BASIC = "club.bookings.member_pricing_basic",
  BOOKINGS_REPORTS_BASIC = "club.bookings.reports_basic",

  // 7.3 Club – Community & Content
  COMMUNITY_NEWS_EVENTS_BASIC = "club.community.news_events_basic",
  COMMUNITY_OFFICIAL_GROUPS_BASIC = "club.community.official_groups_basic",
  COMMUNITY_MODERATION_BASIC = "club.community.moderation_basic",
  COMMUNITY_BADGES_BASIC = "club.community.badges_basic",

  // 7.4 Club – Advanced operational stack (P3, R2+ only – placeholders)
  OPERATIONS_FEDERATION_MEMBER_MANAGEMENT = "club.operations.federation_member_management",
  OPERATIONS_HARBOR_BERTH_STACK = "club.operations.harbor_berth_stack",
  OPERATIONS_INTERNAL_RESOURCES_BOOKING = "club.operations.internal_resources_booking",
  OPERATIONS_COMMUNICATION_HUB = "club.operations.communication_hub",
}
